export default __webpack_public_path__ + "static/media/360.06241bcf.svg";